// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#user-menu[data-v-8d5ed1aa]{padding-bottom:0!important}.logout[data-v-8d5ed1aa],.logout *[data-v-8d5ed1aa]{background-color:#9ca6bd!important;color:#f5f5f5!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
